import { Component, HostBinding, Input, OnDestroy, OnInit, inject, input } from '@angular/core';
import { FormControl, Validators, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconNames } from '@app/shared/enums/icon-names';
import { InputWidth } from '@app/shared/models/input-width.model';
import { UpdateFormDirty } from '@ngxs/form-plugin';
import { Store } from '@ngxs/store';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { getObjectPropertyFromPath } from '@app/core/utils';

@Component({
  selector: 'app-ice-textarea',
  templateUrl: './ice-textarea.component.html',
  styleUrl: './ice-textarea.component.scss',
  imports: [NgClass, FormsModule, ReactiveFormsModule, MatIcon],
})
export class IceTextareaComponent implements OnInit, OnDestroy {
  private controlDirective = inject(NgControl);
  private store = inject(Store);

  IconNames = IconNames;

  // Label
  @Input({ required: true }) label: string;
  @Input() labelHelpText: string;
  @Input() forId = '';

  // Input
  @Input() inputWidth: InputWidth = '';
  @Input() placeholder = '';
  @Input() readonly = false;
  @Input() ngxsFormPath: string;

  // Information
  @Input() longHelpText: string;
  @Input() description: string;

  // Error
  @Input() errorText: string;
  @Input() errorOnTouchedOnly: boolean = false;

  // Cols and rows
  @Input() cols = '20';
  @Input() rows = '4';

  @Input() resize: 'none' | 'both' | 'horizontal' | 'vertical' = 'none';

  // Testing
  testId = input.required<string>();

  @HostBinding('class') get class() {
    return this.inputWidth;
  }

  control: FormControl;

  get isRequired(): boolean {
    return this.control.hasValidator(Validators.required);
  }

  get showIsRequiredError(): boolean {
    return this.control.hasError('required') && this.isFormVisitedOrControlTouched();
  }

  get isErrorState(): boolean {
    return (
      (this.control.invalid && !!this.control.value && (this.control.touched || this.isFormVisitedOrControlTouched())) ||
      this.showIsRequiredError
    );
  }

  private hasFormBeenVisited = false;

  ngOnInit() {
    this.control = this.controlDirective.control as FormControl;

    if (!!this.ngxsFormPath) {
      const state = this.store.snapshot();
      const contextForm = getObjectPropertyFromPath(state, this.ngxsFormPath);
      this.hasFormBeenVisited = contextForm?.dirty;
    }
  }

  isFormVisitedOrControlTouched(): boolean {
    return this.errorOnTouchedOnly ? this.control.touched : this.hasFormBeenVisited;
  }

  ngOnDestroy() {
    if (!!this.ngxsFormPath) {
      this.store.dispatch(new UpdateFormDirty({ dirty: true, path: this.ngxsFormPath }));
    }
  }
}
